import { render } from "./ShilutMain.vue?vue&type=template&id=f2c6de42&scoped=true"
import script from "./ShilutMain.vue?vue&type=script&lang=js"
export * from "./ShilutMain.vue?vue&type=script&lang=js"

import "./ShilutMain.vue?vue&type=style&index=0&id=f2c6de42&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2c6de42"]])

export default __exports__